import { EnvironmentProviders } from '@angular/core';
import { provideUnitsDistributionTemplates } from './components/pools/detail/pool-units-distribution/units-distribution.providers';

export function provideCbUi(): EnvironmentProviders {
  return provideUnitsDistributionTemplates();
}
